import React, { useEffect } from 'react'
import SimpleModal from "components/Modal/SimpleModal";
import { useDispatch, useSelector } from "react-redux";
import IntlMessages from 'util/IntlMessages'
import { Form, Input, Row, Col, Button, Spin, message } from 'antd';
import { DataRequestAction } from "redux/actions/http";
const ResetPasswordModal = () => {

    const usersProps = useSelector(state => state.users)
    const { passwordModelVisible, initialValues, resetPasswordSpinner, success, error } = usersProps

    const resetForm = () => {
        form.resetFields()
    }

    useEffect(resetForm, [passwordModelVisible])

    const dispatch = useDispatch();
    const [form] = Form.useForm()

    const changePassword = values => {
        values._id = initialValues._id
        dispatch(DataRequestAction('PUT', 'changeUserPassword', values, '', 'changingUserPassword', false))
    };
    const toggleChangePasswordModal = () => {
        dispatch({
            type: 'ResetPassword_Modal',
            payload: null,
        })
    }

    if (success) {
        message.success('password changed successfully')
        dispatch({
            type: 'reset_corporateAccount_States'
        })
    }
    if (error) {
        message.error('password could not be changed. try again!')
        dispatch({
            type: 'reset_corporateAccount_States'
        })
    }

    // if(!Change_PharmacyPassword_Modal){
    //      form.resetFields()
    //  }

    return (
        <>

            <SimpleModal
                visible={passwordModelVisible}
                modalFor='ResetPassword_Modal'
                width={500}

                title={'Reset Password'}>

                <Form
                    layout="vertical"
                    name="resetPassword"
                    onFinish={changePassword}
                    form={form}
                >

                    <Row className="gx-d-flex gx-flex-row">
                        <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-pl-0">
                            <Form.Item
                                name="password"
                                label={<IntlMessages id="corporateAccount.passwordModal.newPassword" />}
                                rules={[
                                    {
                                        required: true,
                                        message: <IntlMessages id="corporateAccount.passwordModal.newPassword_message" />,
                                    },
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-px-0">
                            <Form.Item
                                name="confirmPassword"
                                label={<IntlMessages id="corporateAccount.passwordModal.confirmPassword" />}
                                dependencies={['password']}
                                rules={[
                                    {
                                        required: true,
                                        message: <IntlMessages id="corporateAccount.passwordModal.confirmPassword_message" />,
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(<IntlMessages id="corporateAccount.passwordModal.passwordNotMatchMessage" />);
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                            <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">
                                <Form.Item className="gx-mb-0">
                                    <Button type="default" className="gx-pt-0 gx-mb-0 gx-mr-2" htmlType="button" onClick={() => toggleChangePasswordModal()}>
                                        <IntlMessages id="corporateAccount.passwordModal.cancel" />
                                    </Button>
                                </Form.Item>
                                <Form.Item className="gx-mb-0">
                                    {resetPasswordSpinner && <Spin><Button type="primary" className="gx-pt-0 gx-mb-0" disbaled htmlType="button">
                                        <IntlMessages id="corporateAccount.passwordModal.save" />
                                    </Button></Spin>}
                                    {!resetPasswordSpinner && <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit">
                                        <IntlMessages id="corporateAccount.passwordModal.save" />
                                    </Button>}
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </SimpleModal>
        </>
    )
}

export default ResetPasswordModal
